import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const TimezonePickerWrapper = styled.div`
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: auto;
    }
`;

export const Control = styled.div`
    ${BaseStyle.Mixins.gaps.medium};
    display: flex;
    flex: 1;
    flex-direction: column;
    // Since the day header is not part of the control container on mobile we add in padding
    padding-bottom: 8px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.large}
        padding-bottom: initial;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.gaps.semiLarge}
    }
`;
